import { render, staticRenderFns } from "./DiscussTable.vue?vue&type=template&id=9b808cce&scoped=true&"
import script from "./discusstable.js?vue&type=script&lang=js&"
export * from "./discusstable.js?vue&type=script&lang=js&"
import style0 from "./DiscussTable.vue?vue&type=style&index=0&id=9b808cce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b808cce",
  null
  
)

export default component.exports